<template>
  <div class="location-area-list-bd" v-if="funcView.location_area_list">
    <div class="search-hd  clear">
      <!-- <div class="title-hd">
        <i class="icon icon-gongsi"></i>
        {{locationInfo.locationName}}
      </div> -->
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-form-item  v-if="funcView.location_area_add">
          <el-button icon="icon icon-tianjia left-icon" type="warning" round @click="addSite">{{ $t('area_qu_yu') }}</el-button>
        </el-form-item>
        <el-form-item v-if="funcView.location_area_setTarget">
          <el-button  :disabled="!hasBasicGoal" type="warning" @click="setSite()">{{ $t('area_szmbz') }}</el-button>
        </el-form-item>

        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
        </el-form-item>

        <el-form-item
          style="float: right"
          v-if="funcView.location_area_export"
        >
          <el-button
            type="info"
            @click="onExport"
          >
            <i class="icon icon-export-excel"></i>
            {{ $t('com_export') }} Excel
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('area_qu_yu_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item  style="float: right">
          <el-radio-group
            v-model="formSearch.isSetGoal"
            @change="onPageChange({ page: 1 })"
            size="medium"
          >
            <el-radio-button
              :label="item.value"
              v-for="(item, index) in targetData"
              :key="index"
            >{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <div class="query-filter" v-show="isFilter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('area_gsmc') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.orgName" clearable @input="onPageChange({ page: 1 })" style="width: 100%"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('area_xmmc') }}</div>
                <div class="value">
                  <el-input v-model="formSearch.locationName" clearable @input="onPageChange({ page: 1 })" style="width: 100%"></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('area_suo_shu_bu_men') }}</div>
                <div class="value">
                  <custom-select
                    url="DepartmentTree"
                    v-model="formSearch.departmentId"
                    :model="formSearch"
                    :props="{ label: 'bizName', value: 'bizId',checkStrictly: true,map: { bizName: 'departmentName' } }"
                    :params="{ isCountDevice:1 }"
                    :placeholder="$t('com_please_select')"
                    width="100%"
                    ref="tag"
                    type="tree"
                    filterable
                    :dataFilter="departmentTreeFilter"
                    @treeValChange="onPageChange({ page: 1 })"
                    @treeValChangeLabel="onDepartmentLabel"
                    @getList="onDepartmentList"
                    :clearable="false"
                  ></custom-select>
                </div>
              </div>
            </el-col>

          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('area_shai_xuan_xiang') }}：</div>
          <div class="values">
            <el-tag
              v-if="formSearch.orgName"
              closable
              @close="
                formSearch.orgName  = '';
                onPageChange({ page: 1 });
              "
            >
              {{ formSearch.orgName  }}
            </el-tag>
            <el-tag
            v-if="formSearch.locationName "
            closable
            @close="
              formSearch.locationName  = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.locationName  }}
          </el-tag>
            <el-tag
            v-if="formSearch.departmentId"
            closable
            @close="
              formSearch.departmentId = '';
              formSearch.departmentName = '';
              onPageChange({ page: 1 });
            "
          >
            {{ formSearch.departmentName }}
          </el-tag>

            <span
              class="clear"
              @click="onClear"
            >{{ $t('com_clear') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="border-radius: 16px;margin-top: 16px;padding: 24px 24px 0; background: #fff;">
      <div class="table-bd">
        <!-- 美国站是ft² -->
        <custom-table
          v-if="isUs"
          type="checkbox"
          v-model="tableSelect"
          tableCode="portal_location_site_ft"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          @expand-change="onRowClick"
          :slots="['deviceNum', 'goalArea','detailAddress', 'action']"

        >
        <template v-slot:deviceNum="scope">
            <span class="cell-link" v-if="+scope.row.deviceNum>0"  @click="onDevice(scope.row)">{{ scope.row.deviceNum }}</span>
            <span v-else type="text">{{ scope.row.deviceNum }}</span>
          </template>
          <template v-slot:goalArea="scope">
            <span>{{$formatLenLocal(scope.row.goalArea)}}</span>
          </template>
          <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
          <template v-slot:action="scope">
            <el-button type="text" size="mini" v-if="funcView.location_assign" @click.stop="jump('/other/distribution', { active: 'location', locationId: scope.row.locationId,siteId:scope.row.siteId })">{{ $t('area_fen_pei_she_bei') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_edit" @click.stop="editSite(scope.row)">{{ $t('com_edit') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_delete && scope.row.deviceNum == 0" @click.stop="deleteSite(scope.row)">{{ $t('com_delete') }}</el-button>
          </template>
        </custom-table>
        <custom-table
          v-else
          type="checkbox"
          v-model="tableSelect"
          tableCode="portal_location_site"
          :stripe="true"
          @column="setColumn"
          height="100%"
          :data="tableList"
          @sort="sortChange"
          @filter="filterChange"
          :slots="['deviceNum', 'goalArea','detailAddress', 'action']"
        >
          <template v-slot:deviceNum="scope">
            <span class="cell-link" v-if="+scope.row.deviceNum>0" @click.stop="jump('/other/distribution', { active: 'location', locationId: scope.row.locationId,siteId:scope.row.siteId })">{{ scope.row.deviceNum }}</span>
            <span v-else type="text">{{ scope.row.deviceNum }}</span>
          </template>
          <template v-slot:goalArea="scope">
            <span>{{$formatLenLocal(scope.row.goalArea)}}</span>
          </template>
          <template v-slot:detailAddress="scope">{{ scope.row.country || '' }}{{ scope.row.province || '' }}{{ scope.row.city || '' }}{{ scope.row.detailAddress }}</template>
          <template v-slot:action="scope">
            <el-button type="text" size="mini" v-if="funcView.location_assign" @click.stop="jump('/other/distribution', { active: 'location', locationId: scope.row.locationId,siteId:scope.row.siteId })">{{ $t('area_fen_pei_she_bei_1') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_edit" @click.stop="editSite(scope.row)">{{ $t('com_edit') }}</el-button>
            <el-button type="text" size="mini" v-if="funcView.location_delete && scope.row.deviceNum == 0" @click.stop="deleteSite(scope.row)">{{ $t('com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-footer">
        <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
    <location-site-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></location-site-dialog>
    <location-set-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="onPageChange({ page: 1 })"></location-set-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import locationSiteDialog from './children/location_site_dialog.vue';
import locationSetDialog from './children/location_set_dialog.vue';

// i18n-lang-component
// area_qu_yu: 区域// area_szmbz: 设置目标值// area_gsmc: 公司名称// area_xmmc: 项目名称// area_suo_shu_bu_men: 所属部门// area_shai_xuan_xiang: 筛选项// area_fen_pei_she_bei: 分配设备// area_fen_pei_she_bei_1: 分配设备// area_qu_yu_ming_cheng: 区域名称// area_wu_mu_biao: 无目标// area_you_mu_biao: 有目标// area_xin_zeng_qu_yu: 新增区域// area_bian_ji_qu_yu: 编辑区域// area_nqdyscxzdqym: 您确定要删除选中的区域吗？// area_szmbz_1: 设置目标值

export default {
  name: 'locationArea',
  components: { locationSiteDialog, locationSetDialog },
  props: {
    locationName: String,
  },
  watch: {
    'locationName': {
      handler(val) {
        this.formSearch.locationName = val;
        this.formSearch.isSetGoal = this.getJump('isSetGoal') === '' ? ' ' : +this.getJump('isSetGoal');
        this.getTableList();
      },
      immediate: true
    }
  },
  computed: {
    targetData() {
      return [
        {
          label: this.$t('com_all'),
          value: ' ',
        },
        {
          label: this.$t('area_wu_mu_biao'),
          value: 0,
        },
        {
          label: this.$t('area_you_mu_biao'),
          value: 1,
        },
      ];
    },
    // 使用 computed 判断是否存在 isBasicGoal 为 0 的项
    hasBasicGoal() {
      return this.tableSelect.some(item => `${item.isBasicGoal}` === '0');
    }
  },

  data() {
    return {
      tableSelect: [],
      locationId: '',
      isEditfloor: false,
      totalRows: null,
      formSearch: {
        isSetGoal: ' ',
        search: '',
        pageNum: 1,
        pageSize: 50,
        // orgId: '',
        locationId: '',
        floorId: '',
        orgName: '',
        contactName: '',
        departmentId: '',
        departmentName: '',
        showSubsidiary: '',
      },
      isFilter: false,
      tableList: [],
      // 区域
      dialogVisible: false,
      dialogModel: {},
      // 目标值
      dialogVisible2: false,
      dialogModel2: {}
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_area');
    this.getFuncView('/other/location');


  },
  methods: {
    departmentTreeFilter(obj) {
      const ret = [obj];
      const ret2 = this.removeEmptyChildren(ret);
      return ret2;
    },
    removeEmptyChildren(nodes) {
      return nodes.map((item) => {
        // 如果 children 存在且是空数组，则删除 children 属性
        if (Array.isArray(item.children) && item.children.length === 0) {
          const newItem = { ...item }; // 创建一个新的对象，避免直接修改原数据
          delete newItem.children; // 删除 children 属性
          return newItem; // 返回没有 children 属性的对象
        }

        // 如果有子节点，递归调用 removeEmptyChildren
        if (item.children && item.children.length > 0) {
          return { ...item, children: this.removeEmptyChildren(item.children) };
        }

        return item; // 其他情况直接返回
      });
    },
    onDepartmentList(list) {
      this.departmentList = list;
    },
    // i18nCallback() {
    //   this.formSearch.isSetGoal = +this.getJump('isSetGoal');
    // },
    // 获取表格数据
    getTableList: function () {
      this.formSearch.orgId = this.userInfo.rootOrgId;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.locationSitePage, { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    changfloorId(floorId = '') {
      if (!this.isEditfloor) {
        this.formSearch.floorId = floorId;
        this.getTableList();
      }
    },
    // 区域
    addSite() {
      this.dialogVisible = true;
      this.dialogModel = {
        type: 'add',
        title: this.$t('area_xin_zeng_qu_yu'),
        data: {
          locationId: null
        }
      };
    },
    editSite(row) {
      this.dialogVisible = true;
      this.dialogModel = {
        type: 'edit',
        title: this.$t('area_bian_ji_qu_yu'),
        data: {
          id: row.siteId,
          ...row
        }
        // data: row
      };
    },

    deleteSite({ siteId }) {
      this.$showConfirm(this.$t('area_nqdyscxzdqym'))
        .then(() => {
          this.$postJSON(`${apis.locationSiteDelete}/${siteId}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('com_handle_success'),
                type: 'success'
              });
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    // 设置区域目标值
    setSite() {
      this.dialogVisible2 = true;
      this.dialogModel2 = {
        type: 'setBatch',
        title: this.$t('area_szmbz_1'),
        data: this.tableSelect.map(i => i.siteId)
      };
    },
    onDepartmentLabel(Label) {
      this.formSearch.departmentName = Label;
    },
    onClear() {
      this.formSearch.orgName = '';
      this.formSearch.locationName = '';
      this.formSearch.departmentId = '';
      this.formSearch.departmentName = '';
      // initValue会调用到
      this.onPageChange({ page: 1 });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.isEditfloor = false;
      this.getTableList();
    },
    // 导出
    onExport: function () {
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.exportTable('locationSiteExport', { ...this.formSearch, departmentId: this.formSearch.departmentId ? this.formSearch.departmentId[this.formSearch.departmentId.length - 1] : '' });
    },
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.location-area-list-bd {
  margin: 24px 0;
  .el-radio-button:first-child .el-radio-button__inner {
      border-radius: 20px 0 0 20px;
    }

    .el-radio-button:last-child .el-radio-button__inner {
      border-radius: 0 20px 20px 0;
    }
  .search-hd {
    padding: 24px;
    // height: 90px;
    /* 字体色/#FFFFFF */
    background: #ffffff;
    border-radius: 16px;
    .title-hd {
      font-weight: bold;
      font-size: 18px;
      line-height: 40px;
      margin-bottom: 24px;
      /* 字体色/$--color-text-primary */
      color: $--color-text-primary;
      .icon {
        font-size: 20px;
        color: $--color-text-primary;
        margin-right: 12px;
      }
    }
     .form-screen {
      // min-height: 40px;
      // display: flex;
      // align-items: flex-start;
      .el-form-item{
        margin-bottom: 0;
      }
      .tag-item {
        flex: 1;
        width: 0;
        .el-form-item__content{
          width: 100%;
        }
        .item-tag {
          // height: 40px;
          line-height: 40px;
          display: flex;
          align-items: flex-start;

          // max-width: 520px;
          // overflow: auto;
          .lable {
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            line-height: 140%;
            color: $--color-text-secondary;
            margin-right: 8px;
            margin-top: 8px;
          }
          .tag-list {
            display: flex;
            flex-direction: row;
            // align-items: center;
            flex: 1;
            flex-wrap: wrap;
            // overflow-x: auto;
            margin-right: 8px;
            .tag {
              height: 30px;
              color: #1a1a1a;
              background: #f8f8f8;
              padding: 0 16px;
              background: #f8f8f8;
              line-height: 30px;
              margin-right: 8px;
              margin-bottom: 8px;
              border-radius: 100px;
              cursor: pointer;
              flex: none;
              .name {
                margin-right: 4px;
              }
              .icon {
                font-size: 12px;
                color: $--color-primary;
                margin-left: 11px;

              }

              &.active {
                color: #ffffff;
                background: $--color-primary;
              }
            }
          }

          .icon-shezhi,
          .icon-guanbi1,
          .icon-tianjia {
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: $--color-text-primary;
            border-radius: 100px;
            background-color: $--color-warning;
            margin-right: 8px;
            cursor: pointer;
          }
          .icon-tianjia {
            color: $--color-primary;
            background-color: #f8f8f8;
          }
        }
      }
      .icon-filter {
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font-size: 14px;
        width: 40px;
        height: 40px;
        color: $--color-text-primary;
        box-shadow: 0 0 0 1.5px #202945 inset;
        border-radius: 50px;
        cursor: pointer;
      }
    }
  }

  // 表格
  .table-bd {
    height: 450px;
  }
  .table-footer {
    margin-top: 16px;
  }
}
</style>
